import { render, staticRenderFns } from "./ProposalArgument.vue?vue&type=template&id=2d8c4a50&scoped=true&"
import script from "./ProposalArgument.vue?vue&type=script&lang=js&"
export * from "./ProposalArgument.vue?vue&type=script&lang=js&"
import style0 from "./ProposalArgument.vue?vue&type=style&index=0&id=2d8c4a50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c4a50",
  null
  
)

export default component.exports